import React, { useEffect, useState } from "react";

function About() {
  const [text, setText] = useState("");
  const textArray = [
    " Web Developer.",
    "HTML/CSS.",
    "NodeJS.",
    "JS.",
    "React.",
    "Express.",
    "Git.",
  ];
  const [textIndex, setTextIndex] = useState(0);

  useEffect(() => {
    let currentIndex = 0;
    let currentText = "";
    const interval = setInterval(() => {
      if (currentIndex < textArray[textIndex].length) {
        currentText += textArray[textIndex][currentIndex];
        setText(currentText);
        currentIndex++;
      } else {
        clearInterval(interval);
        setTimeout(() => {
          setText("");
          setTextIndex((textIndex + 1) % textArray.length);
        }, 1000);
      }
    }, 100);
    return () => clearInterval(interval);
    // eslint-disable-next-line
  }, [textIndex]);

  return (
    <main>
      <div className="container" id="container">
        <div className="infomy">
          <p className="infomy__p">Bonjour, je suis</p>
          <h1 className="infomy__title">
            Romain
            <span>Kordalski</span>
          </h1>
          <span id="typed-text">{text}</span>
        </div>
      </div>
      <div className="loader__link">
        <a
          href="https://romainkordalski.vercel.app/"
          target="_blank"
          rel="noopener noreferrer"
          className="portfolio-link"
        >
          Découvrez mon nouveau portfolio
        </a>
      </div>
    </main>
  );
}

export default About;
